export default __webpack_public_path__ + "static/media/commander_xp_4.d85ec679.png";